import { Action } from '@ngrx/store'
import * as LicenseGenerationSettingsTypes from './license-generation-settings.types'

export class FetchLicenseGenerationSettingsRequest implements Action {
  readonly type =
    LicenseGenerationSettingsTypes.FETCH_LICENSE_GENERATION_SETTINGS_REQUEST
  constructor() {}
}

export class FetchLicenseGenerationSettingsSuccess implements Action {
  readonly type =
    LicenseGenerationSettingsTypes.FETCH_LICENSE_GENERATION_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchLicenseGenerationSettingsFailure implements Action {
  readonly type =
    LicenseGenerationSettingsTypes.FETCH_LICENSE_GENERATION_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateLicenseGenerationSettingsRequest implements Action {
  readonly type =
    LicenseGenerationSettingsTypes.UPDATE_LICENSE_GENERATION_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateLicenseGenerationSettingsSuccess implements Action {
  readonly type =
    LicenseGenerationSettingsTypes.UPDATE_LICENSE_GENERATION_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateLicenseGenerationSettingsFailure implements Action {
  readonly type =
    LicenseGenerationSettingsTypes.UPDATE_LICENSE_GENERATION_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = LicenseGenerationSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = LicenseGenerationSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchLicenseGenerationSettingsSuccess
  | FetchLicenseGenerationSettingsFailure
  | FetchLicenseGenerationSettingsRequest
  | UpdateLicenseGenerationSettingsRequest
  | UpdateLicenseGenerationSettingsSuccess
  | UpdateLicenseGenerationSettingsFailure
  | SetDefaultData
  | UpdateField
